import { Divider } from 'antd';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface CustomDividerProps {
  className?: string;
  orientation?: 'left' | 'right' | 'center';
  dashed?: boolean;
}
export const CustomDivider: FC<CustomDividerProps> = ({ className = '', orientation = 'center', dashed = false }) => {
  return (
    <Divider
      className={twMerge(
        'my-4',
        orientation === 'left' && 'text-start',
        orientation === 'right' && 'text-end',
        dashed ? 'border-dashed' : 'border-solid',
        className,
      )}
      dashed={dashed}
      orientation={orientation}
    />
  );
};

export default CustomDivider;
